import {
  ChangeRoute,
  ChangeRouteOptionVm,
} from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';
import { ChangeResolution } from '@/features/dashboard/bookingChanges/types/dto/ChangeResolution.ts';

/**
 * Opisy tras wprowadzenia paczki (blok „Jak paczka wchodzi w życie” w kroku W2)
 * i przełożenie wyboru na `ChangeResolution` z żądania `resolve`.
 */
export const CHANGE_ROUTE_OPTIONS: ChangeRouteOptionVm[] = [
  {
    route: ChangeRoute.CLIENT_ACCEPTANCE,
    title: 'Wyślij do akceptacji',
    tag: 'zalecane',
    description:
      'Zapisujący dostaje link z listą zmian i dokumentami. Paczka wchodzi dopiero po jego zgodzie; do tego czasu edycja jest zablokowana.',
  },
  {
    route: ChangeRoute.IMMEDIATE,
    title: 'Wprowadź od razu',
    tag: 'bez zgody',
    description:
      'Wartości stają się bieżące natychmiast, zapisujący dostaje samo powiadomienie. Do zmian uzgodnionych telefonicznie lub naprawy błędu operatora.',
  },
];

/**
 * Trasa → rozstrzygnięcie backendu.
 *
 * Ścieżka „do akceptacji” ma dwa warianty: z aneksem (`CLIENT_ACCEPTANCE_WITH_AMENDMENT`),
 * gdy paczka każe podpisać dokumenty, i bez niego. Wybór aneksu wymusza
 * niepustą listę `amendmentTourConsentIds`.
 */
export const toChangeResolution = (
  route: ChangeRoute,
  withAmendment: boolean,
): ChangeResolution => {
  if (route === ChangeRoute.IMMEDIATE) {
    return ChangeResolution.APPLY_NOW;
  }
  return withAmendment
    ? ChangeResolution.CLIENT_ACCEPTANCE_WITH_AMENDMENT
    : ChangeResolution.CLIENT_ACCEPTANCE;
};
